// import trackFields from "_module/definition/trackFields"

export const  MlPrsSearchButtonType ={
    BUTTON :1,
    MENU_ITEM: 2
}

export const prsUpdateFields = [
    {key: "prsWorkTunecode" , resultKey : "workTunecode"}, 
    {key: "prsSearchDateTime" , resultKey : "dateTime"}, 
    {key: "prsWorkPublishers" , resultKey : "workPublishers"}, 
    {key: "prsWorkWriters" , resultKey : "workWriters"}, 
    {key: "prsWorkTitle" , resultKey : "workTitle"}, 
    {key: "cTagMcpsOwner" , resultKey : "cTagMcpsOwner"}, 
    {key: "cTagNorthAmerican" , resultKey : "cTagNorthAmerican"}, 
]

export const prsSearchRefreshDataType = {
    TRACK : 1,
    ALBUM_TRACKS : 2,
    PLAYLIST_TRACKS: 3
}